/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...



document.addEventListener('DOMContentLoaded', function () {
  (function () {
    const swatchInputs = document.querySelectorAll('.product-form__swatch__input');

    function insertBadgeIfNeeded() {
      const oneTimeTextSpan = document.querySelector('.appstle_one_time_text');
      if (!oneTimeTextSpan) return;

      // Remove existing badge
      const existingBadge = document.querySelector('.discount-badge');
      if (existingBadge) {
        existingBadge.remove();
      }

      let badgeText = null;

      // Check selected swatch and decide badge text
      swatchInputs.forEach(input => {
        if (input.checked) {
          if (input.value.includes('3 Month')) {
            badgeText = ' 5% OFF';
          } else if (input.value.includes('6 Month')) {
            badgeText = ' 10% OFF';
          }
        }
      });

      // Insert badge if applicable
      if (badgeText) {
        const badge = document.createElement('span');
        badge.textContent = badgeText;
        badge.className = 'discount-badge';
        oneTimeTextSpan.insertAdjacentElement('afterend', badge);
        console.log(`✅ Badge shown: ${badgeText}`);
      } else {
        console.log("ℹ️ No 3/6 Month selected – badge hidden");
      }
    }

    // Listen to changes on swatch inputs
    swatchInputs.forEach(input => {
      input.addEventListener('change', function () {
        setTimeout(insertBadgeIfNeeded, 100);
      });
    });

    // Watch for .appstle_one_time_text if added dynamically
    const observer = new MutationObserver(() => {
      if (document.querySelector('.appstle_one_time_text')) {
        insertBadgeIfNeeded();
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Fallback run
    setTimeout(insertBadgeIfNeeded, 1000);
  })();
});


// document.addEventListener('DOMContentLoaded', function () {
//   (function () {
//     // only target swatches that have BOTH classes
//     const swatchInputs = document.querySelectorAll('.product-form__swatch__input.hideOneTimePuchaseForMonth');
//     let removedOption = null; // store removed node for restore

//     function handleSubscriptionOptions() {
//       const wrapper = document.querySelector('.appstle_subscription_wrapper');
//       if (!wrapper) return;

//       let options = wrapper.querySelectorAll('.appstle_subscription_wrapper_option');

//       let isOneMonthSelected = false;
//       swatchInputs.forEach(input => {
//         if (input.checked && input.value.includes('1 Month')) {
//           isOneMonthSelected = true;
//         }
//       });

//       if (isOneMonthSelected) {
//         if (options.length > 1) {
//           removedOption = options[1]; // store the second option
//           options[1].remove();
//           console.log("🗑️ Removed second subscription option (1 Month selected)");
//         }
//       } else {
//         // refresh options after potential re-render
//         options = wrapper.querySelectorAll('.appstle_subscription_wrapper_option');

//         if (removedOption && options.length < 2) {
//           wrapper.appendChild(removedOption); // restore only if missing
//           removedOption = null;
//           console.log("🔄 Restored second subscription option (not 1 Month)");
//         } else {
//           console.log("ℹ️ Not restoring because wrapper already has 2 options");
//         }
//       }
//     }

//     // Listen to swatch changes
//     swatchInputs.forEach(input => {
//       input.addEventListener('change', function () {
//         setTimeout(handleSubscriptionOptions, 100);
//       });
//     });

//     // Fallback run
//     if (swatchInputs.length > 0) {
//       setTimeout(handleSubscriptionOptions, 1000);
//     }
//   })();
// });
